module.exports = __webpack_public_path__ + "static/media/tiktok_logo.0993e324.png";